<template>
  <div>
    <div class="row" style="padding: 25px">
      <section>
        <div class="row">
          <div class="col-md-12">
            <h4>Título da Reunião: {{ scheduled.title }}</h4>
          </div>
        </div>
        <div class="row" style="margin-top: 20px">
          <div class="col-md-12">Participantes convidados:</div>
        </div>
      </section>
    </div>
    <div class="row" style="margin-top: -35px; padding: 25px">
      <table class="table table-striped" style="width: 100%">
        <thead>
          <tr>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="participant in scheduled.participants"
            :key="participant.id"
          >
            <td width="40%">{{ participant.name }}</td>
            <td width="40%">{{ participant.email }}</td>
            <td width="20%">
              <span
                class="badge"
                :class="
                  participant.status == 1
                    ? 'badge-warning'
                    : participant.status == 2
                    ? 'badge-success'
                    : 'badge-danger'
                "
                >{{
                  participant.status == 1
                    ? "Aguardando"
                    : participant.status == 2
                    ? "Confirmado"
                    : "Rejeitado"
                }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-2">
        <button class="btn btn-success" @click="manage(2)">
          Aceitar Convite
        </button>
      </div>
      <div class="col-md-2">
        <button class="btn btn-danger" @click="manage(3)">
          Rejeitar Convite
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import VueQrcode from "vue-qrcode";
import swal from "sweetalert";

export default {
  data() {
    return {
      scheduled: {
        title: "",
      },
    };
  },
  methods: {
    manage(status) {
      let self = this;
      let id = self.$route.params.hash;
      let api = self.$store.state.api + "manage_status/" + id + "/" + status;

      self.$http
        .post(api, status)
        .then((response) => {
          swal("Sucesso", "Presença atualizada com sucesso!", "success");
          this.getParticipants();
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getParticipants: function () {
      let self = this;
      let id = self.$route.params.hash;
      let api = self.$store.state.api + "scheduled/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.scheduled = response.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.hash;

    console.log(id);
    if (id) {
      self.getParticipants(id);
    }
  },
  components: {
    vSelect,
    VueQrcode,
  },
};
</script>

<style scoped>
.meet-name {
  margin-left: 15px;
  font-size: 36px;
  font-weight: bold;
  border-left: 5px solid #00ee38;
  padding: 13px;
}
.meet-hour {
  margin-left: 15px;
  font-size: 36px;
  font-weight: bold;
  padding: 13px;
}
.meet-time {
  margin-left: 35px;
}
.cont {
  margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleRooms/Confirmation.vue